import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import moment from 'moment';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { getInternalRemarksHistoryApi } from '../apiService';
import { trackActivity } from '../../../utils/mixpanel';
import { dateMonthYearFormatTime } from '../../../constants';

const InternalRemarksHistory = ({ remarksHistory, onToggleModal }) => {
    const [isLoading, setLoading] = useState(true);
    const [historyList, setHistoryList] = useState([]);

    useEffect(() => {
        setLoading(true);
        globalGetService(getInternalRemarksHistoryApi({ slug: remarksHistory?.data?.slug }))
            .then((response) => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    setHistoryList(response?.data?.data || []);
                }
            });
        trackActivity('Page Viewed', { page_title: 'Internal Remarks History' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [remarksHistory?.data?.slug]);

    return (
        <Dialog aria-labelledby="internal-remarks-history-dialog-title" className='add-lease-dialog' maxWidth='md' fullWidth open={true}>
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="internal-remarks-history-dialog-title">
                Internal Remarks History
            </DialogTitle>
            <DialogContent dividers style={{ minWidth: '400px' }}>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={160} sx={{ borderRadius: '6px' }} />
                ) : (
                    <TableContainer>
                        <Table className="mui-table-format" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ minWidth: '160px' }}>Previous Value</TableCell>
                                    <TableCell sx={{ minWidth: '160px' }}>New Value</TableCell>
                                    <TableCell sx={{ minWidth: '110px' }}>Status</TableCell>
                                    <TableCell sx={{ minWidth: '130px' }}>Updated By</TableCell>
                                    <TableCell sx={{ minWidth: '150px' }}>Updated At</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {historyList?.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            <Typography variant="body2" color="text.secondary">No history available</Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    historyList.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{item?.previous_value || '--'}</TableCell>
                                            <TableCell>{item?.new_value || '--'}</TableCell>
                                            <TableCell>{item?.invoice_status_label || '--'}</TableCell>
                                            <TableCell>{item?.changed_by_name || '--'}</TableCell>
                                            <TableCell>{item?.changed_at ? moment(item.changed_at).format(dateMonthYearFormatTime) : '--'}</TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions sx={{ paddingRight: '16px', cursor: 'pointer' }}>
                <Button className="cancel-btn" variant="outlined" size="small" onClick={() => onToggleModal()}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default InternalRemarksHistory;
